// extracted by mini-css-extract-plugin
module.exports = {"feed":"FeedPhotos_feed__1f_1A"};